<div class="skeleton-container">
    <div class="skeleton-title"></div>
    <ng-container *ngFor="let line of [].constructor(lines)">
        <div class="skeleton-line"></div>
    </ng-container>
</div>
